import { Search } from '@mui/icons-material';
import { Slider } from '@mui/material';
import { useState } from 'react';
import '../../components/app/common.scss';
import Checkbox from './Checkbox';
import toList from './ComponentUtil';
import CustomTextField from './CustomTextField';

function CustomMultiSelect({ data = [], options = [], title, name = '', maxOptions = 5, onSubmit = () => {},
    className = 'category', searchable = true, onChange = undefined, range = false, min = 0, max = 20000 }) {
    const [searchKey, setSearchKey] = useState('');
    const [rangeValue, setRangeValue] = useState([0, 0]);
    const filtered = options?.filter(o => o?.label?.toLowerCase()?.includes(searchKey));
    const [showMore, setShowMore] = useState(true);


    return (
        <div className={className}>
            <div className="title">{title}</div>
            {
                searchable && <div className="search-bar">
                    <CustomTextField name='' placeholder={"Search " + title} onChange={(e) => {
                        setSearchKey(e?.target?.value)
                    }
                    } />
                    <Search className='icon' />
                </div>
            }
            <div className="filter-options" style={{overflow: showMore ? 'hidden' : 'auto'}}>
                {toList(filtered, undefined, (c, i) =>
                    <div className="filter" >
                        <div className="option">
                            <Checkbox name={name} value={c.label} checked={data.includes(c.label)} onChange={onChange} />
                            <div className="name">{c.label}</div>
                        </div>
                        <div className="count">
                            <div className="text">{c.count}</div>
                        </div>
                    </div>
                )}
            </div>
            {
                filtered.length > maxOptions && showMore && <div className='more-count' onClick={(e) => setShowMore(false)} >+{filtered.length - maxOptions} More {title}</div>
            }
            {
                range && <>
                    <Slider
                        getAriaLabel={() => 'Temperature range'}
                        value={rangeValue}
                        onChange={(e, v) => setRangeValue(v)}
                        min={min}
                        max={max}
                        valueLabelDisplay="auto"
                    />
                    <div className="min-max">
                        <div className="min-max-input">
                            <CustomTextField name='' type='number' label="Min" placeholder="Any" value={rangeValue[0]} onChange={(e) =>
                                setRangeValue([e?.target?.value, rangeValue[1]])} />
                            <div className="currency">₹</div>
                        </div>
                        <div className="to">To</div>
                        <div className="min-max-input">
                            <CustomTextField name='' type='number' label="Max" placeholder="Any" value={rangeValue[1]} onChange={(e) => setRangeValue([rangeValue[0], e?.target?.value])} />
                            <div className="currency">₹</div>
                        </div>
                    </div>
                </>
            }
            <div className="submit-btn" onClick={onSubmit}>Apply</div>
        </div>
    );
}

export default CustomMultiSelect;